export type ComparisonVisualVariant =
  | 'blue'
  | 'violet'
  | 'teal'
  | 'amber'
  | 'rose'
  | 'cyan'
  | 'emerald'
  | 'indigo'
  | 'fuchsia';

export interface ComparisonTheme {
  primary: string;
  primaryRgb: string;
  soft: string;
  mesh: string;
  dark: string;
}

export const COMPARISON_THEMES: Record<ComparisonVisualVariant, ComparisonTheme> = {
  blue: {
    primary: '#1769ff',
    primaryRgb: '0, 102, 255',
    soft: '#e8f1ff',
    mesh: 'radial-gradient(ellipse 80% 60% at 20% 20%, rgba(0,102,255,0.14), transparent 55%), radial-gradient(ellipse 70% 50% at 85% 10%, rgba(59,130,246,0.12), transparent 50%), radial-gradient(ellipse 60% 40% at 90% 85%, rgba(14,165,233,0.08), transparent 45%)',
    dark: '#0c1222',
  },
  violet: {
    primary: '#7c3aed',
    primaryRgb: '124, 58, 237',
    soft: '#f3e8ff',
    mesh: 'radial-gradient(ellipse 80% 60% at 15% 25%, rgba(124,58,237,0.14), transparent 55%), radial-gradient(ellipse 70% 50% at 90% 15%, rgba(139,92,246,0.1), transparent 50%), radial-gradient(ellipse 55% 45% at 80% 90%, rgba(236,72,153,0.07), transparent 45%)',
    dark: '#110b1a',
  },
  teal: {
    primary: '#0d9488',
    primaryRgb: '13, 148, 136',
    soft: '#ccfbf1',
    mesh: 'radial-gradient(ellipse 80% 60% at 20% 20%, rgba(13,148,136,0.14), transparent 55%), radial-gradient(ellipse 70% 50% at 85% 20%, rgba(20,184,166,0.11), transparent 50%), radial-gradient(ellipse 55% 40% at 75% 88%, rgba(6,182,212,0.08), transparent 45%)',
    dark: '#0a1614',
  },
  amber: {
    primary: '#d97706',
    primaryRgb: '217, 119, 6',
    soft: '#fff7ed',
    mesh: 'radial-gradient(ellipse 80% 60% at 18% 22%, rgba(217,119,6,0.12), transparent 55%), radial-gradient(ellipse 70% 50% at 88% 18%, rgba(245,158,11,0.1), transparent 50%), radial-gradient(ellipse 55% 40% at 82% 88%, rgba(234,88,12,0.07), transparent 45%)',
    dark: '#1a1208',
  },
  rose: {
    primary: '#e11d48',
    primaryRgb: '225, 29, 72',
    soft: '#ffe4e6',
    mesh: 'radial-gradient(ellipse 80% 60% at 22% 20%, rgba(225,29,72,0.12), transparent 55%), radial-gradient(ellipse 70% 50% at 88% 22%, rgba(244,63,94,0.1), transparent 50%), radial-gradient(ellipse 55% 40% at 78% 85%, rgba(251,113,133,0.08), transparent 45%)',
    dark: '#1a0a0e',
  },
  cyan: {
    primary: '#0891b2',
    primaryRgb: '8, 145, 178',
    soft: '#ecfeff',
    mesh: 'radial-gradient(ellipse 80% 60% at 20% 18%, rgba(8,145,178,0.14), transparent 55%), radial-gradient(ellipse 70% 50% at 90% 20%, rgba(6,182,212,0.11), transparent 50%), radial-gradient(ellipse 55% 40% at 85% 88%, rgba(14,165,233,0.08), transparent 45%)',
    dark: '#0a1418',
  },
  emerald: {
    primary: '#059669',
    primaryRgb: '5, 150, 105',
    soft: '#d1fae5',
    mesh: 'radial-gradient(ellipse 80% 60% at 18% 22%, rgba(5,150,105,0.13), transparent 55%), radial-gradient(ellipse 70% 50% at 88% 18%, rgba(16,185,129,0.1), transparent 50%), radial-gradient(ellipse 55% 40% at 80% 88%, rgba(52,211,153,0.07), transparent 45%)',
    dark: '#0a1510',
  },
  indigo: {
    primary: '#4f46e5',
    primaryRgb: '79, 70, 229',
    soft: '#e0e7ff',
    mesh: 'radial-gradient(ellipse 80% 60% at 20% 20%, rgba(79,70,229,0.14), transparent 55%), radial-gradient(ellipse 70% 50% at 88% 18%, rgba(99,102,241,0.11), transparent 50%), radial-gradient(ellipse 55% 40% at 78% 88%, rgba(129,140,248,0.08), transparent 45%)',
    dark: '#0c0e1a',
  },
  fuchsia: {
    primary: '#c026d3',
    primaryRgb: '192, 38, 211',
    soft: '#fae8ff',
    mesh: 'radial-gradient(ellipse 80% 60% at 18% 22%, rgba(192,38,211,0.12), transparent 55%), radial-gradient(ellipse 70% 50% at 90% 20%, rgba(217,70,239,0.1), transparent 50%), radial-gradient(ellipse 55% 40% at 82% 88%, rgba(232,121,249,0.07), transparent 45%)',
    dark: '#160a18',
  },
};

export function getComparisonTheme(variant?: ComparisonVisualVariant): ComparisonTheme {
  return COMPARISON_THEMES[variant ?? 'blue'];
}
